import React, { useState } from "react";
import classNames from "classnames";
import Button from "theme/components/atoms/Button";
import Stars from "theme/components/molecules/Stars";
import { FormattedMessage, FormattedDate, useIntl } from "react-intl";
import Wysiwyg from "theme/modules/WysiwygV2";
import { H4 } from "theme/components/atoms/Typography/Heading";
import { BodyFade } from "theme/components/atoms/Typography/Body";

const Review = ({ review, ...props }) => {
  const intl = useIntl();
  const [closed, setClosed] = useState(review.comment.raw.length > 300);
  return (
    <article
      {...props}
      className={classNames("review", {
        "review--closed": closed,
      })}
      itemScope
      itemType="http://schema.org/Review"
    >
      <meta
        itemProp="dateCreated"
        content={intl.formatDate(new Date(review.creationDate))}
      />
      <meta itemProp="description" content={review.comment.raw} />
      <header className="review__head">
        <div className="review__main-title">
          <div
            className="review__stars"
            itemProp="reviewRating"
            itemType="http://schema.org/Rating"
          >
            <meta itemProp="value" content={review.rating} />
            <meta itemProp="bestRating" content="5" />
            <Stars rating={review.rating} size="small" />
          </div>
          <div className="review__title">
            <H4 as="h3">{review.title}</H4>
          </div>
        </div>
        <div
          className="review__subtitle"
          itemProp="author"
          itemScope
          itemType="https://schema.org/Person"
        >
          <meta itemProp="name" content={review.author.displayName} />
          <BodyFade>
            <FormattedMessage
              id="modules.Reviews.Review.writtenBy"
              defaultMessage={`by {author} on {date}`}
              values={{
                author: review.author.displayName,
                date: (
                  <FormattedDate
                    value={new Date(review.creationDate)}
                    year="numeric"
                    month="long"
                    day="numeric"
                  />
                ),
              }}
            />
          </BodyFade>
        </div>
      </header>
      <div className="review__content">
        <Wysiwyg content={review.comment} />

        {closed && (
          <div className="review__toggle">
            <Button
              onClick={() => setClosed(false)}
              size="mini"
              appearance="default"
            >
              <FormattedMessage
                id="modules.Reviews.Review.open"
                defaultMessage="Open review"
              />
            </Button>
          </div>
        )}
      </div>
    </article>
  );
};

export default Review;
